<template>
  <div>
    <sc-form :rules="rulesDraft" v-if="rulesDraft" @change="updateFields" :form="quoteFreightComparison" @submit="submit">
      <template slot="fields" slot-scope=" { fields }">
        <sc-real-time-quotation/>
        <div class="columns">
          <div class="column">
            <sc-quote-rules :fields="fields" />
          </div>
        </div>
        <sc-basic-data :delivery_methods_added="delivery_methods_added" :showDraftLogistics="showDraftLogistics" :fields="fields" />
        <hr />
        <div class="columns">
          <div class="column is-3">
            <sc-field label="Métodos de entrega">
              <sc-select v-model="fields.delivery_method" placeholder="Selecione um método de entrega">
                <option :value="null">
                  Selecione um método de entrega
                </option>
                <option v-for="delivery_method in deliveryMethodListFilter" :value="delivery_method" :key="delivery_method.id">
                  {{delivery_method.name}}
                </option>
              </sc-select>
            </sc-field>
          </div>
          <div class="buttons has-addons">
            <sc-button theme="primary" text="Adicionar" class="button-add" :disabled="!fields.delivery_method" @click="addDeliveryMethod(fields.delivery_method, fields.origin_zip_code)" />
            <sc-button theme="default" class="button-add" :disabled="listContract.length === 0" @click="deleteDeliveryMethods()" text="Limpar métodos de entrega" />
          </div>
        </div>
        <div class="columns" v-for="dm in listContract" :key="dm.id">
          <div class="column">
            <sc-logistic-contracts :delivery="dm" />
          </div>
        </div>
        <sc-volume :fields="fields" />
      </template>
      <template slot="actions" slot-scope="{ isValid }">
        <sc-button @click="backUrl" theme="default" text="Voltar" />
        <sc-button type="submit" theme="primary" text="Calcular" />
      </template>
    </sc-form>
    <sc-quote-test-return :fields="newFields" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScForm,
  ScInput,
  ScField,
  ScButton,
  ScDialog,
  ScSelect,
  ScSwitch,
} from '@intelipost-js/secure-components';
import ScBasicData from '../sc-basic-data/ScBasicData';
import ScLogisticContracts from '../sc-logistic-contracts/ScLogisticContratcs';
import ScVolume from '../sc-volume/ScVolume';
import ScQuoteRules from '../sc-quote-rules/ScQuoteRules';
import ScQuoteTestReturn from '../sc-quote-test-return/ScQuoteTestReturn';
import ScRealTimeQuotation from '../sc-real-time-quotation/ScRealTimeQuotation.vue';


const {
  mapState,
  mapActions,
  mapGetters,
  mapMutations,
} = createNamespacedHelpers('quote/freightQuote');

export default {
  name: 'sc-logistic-draft-test',
  data() {
    return {
      newFields: {},
      fields: {},
      skip_return_modes: true,
      showDraftLogistics: true,
      delivery_methods_added: [],
      delivery_methods_available: {},
    };
  },
  computed: {
    ...mapState([
      'quoteFreightComparison',
      'logistic_contract_mode',
      'shipment_type',
      'delivery_method_list',
      'contract_list',
      'skip_quote_rules',
    ]),
    ...mapGetters([
      'listContract',
      'listContractId',
    ]),
    deliveryMethodListFilter() {
      const shipment_type = this.shipment_type ? 'RETURN' : 'NORMAL';
      return this.delivery_method_list
      .filter(d => !this.listContract.find(l => l.id === d.id))
      .filter(e => e.shipment_type.includes(shipment_type));
    },
    rulesDraft() {
      const {
        newFields,
      } = this;

      const {
        volumes = [],
      } = newFields;

      const newRules = volumes.map((volume, volumeKey) => ({
        [volumeKey]: {
          type: 'object',
          required: true,
          fields: {
            length: [{
              required: true,
              message: 'Preencha o comprimento',
              trigger: 'input',
              validator: (rule, value, callback) => {
                if (!value || value < 0) {
                  callback(new Error(rule.message));
                }
                callback();
              },
            }],
            weight: [{
              required: true,
              message: 'Preencha o peso',
              trigger: 'input',
              validator: (rule, value, callback) => {
                if (!value || value < 0) {
                  callback(new Error(rule.message));
                }
                callback();
              },
            }],
            height: [{
              required: true,
              message: 'Preencha a altura',
              trigger: 'input',
              validator: (rule, value, callback) => {
                if (!value || value < 0) {
                  callback(new Error(rule.message));
                }
                callback();
              },
            }],
            width: [{
              required: true,
              message: 'Preencha a largura',
              trigger: 'input',
              validator: (rule, value, callback) => {
                if (!value || value < 0) {
                  callback(new Error(rule.message));
                }
                callback();
              },
            }],
            cost_of_goods: [{
              min: 0,
              message: 'Preencha o valor da nota fiscal',
              trigger: 'input',
              validator: (rule, value, callback) => {
                if (value < 0) {
                  callback(new Error(rule.message));
                }
                callback();
              },
            }],
          },
        },
      })).reduce((itemA, itemB) => ({
        ...itemA,
        ...itemB,
      }), {});

      return {
        origin_zip_code: [{
          type: 'string',
          required: true,
          trigger: 'input',
          message: 'Informe o CEP completo no formato 00000-000',
          validator: (rule, value, callback, fields) => {
            const errors = [];
            if (fields.origin_zip_code.replace('-', '').length < 8) {
              errors.push(new Error(rule.message, rule.field));
              callback(errors);
            }

            callback(errors);
          },
        }],
        additional_business_days: [{
          message: 'Preencha uma quantidade de dias',
          trigger: 'input',
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error(rule.message));
            }
            callback();
          },
        }],
        destination_zip_code: [{
          type: 'string',
          required: true,
          trigger: 'input',
          message: 'Informe o CEP completo no formato 00000-000',
          validator: (rule, value, callback, fields) => {
            const errors = [];

            if (fields.destination_zip_code.length < 9) {
              errors.push(new Error(rule.message, rule.field));
              callback(errors);
            }

            callback(errors);
          },
        }],
        volumes: [{
          type: 'array',
          fields: newRules,
        }],
      };
    },
  },
  methods: {
    ...mapActions([
      'quoteGetLogistics',
      'quoteGetContractsByDeliveryMethod',
      'quoteByVolume',
      'cleanUpdateContractId',
    ]),
    ...mapMutations([
      'resetContractList',
    ]),
    updateFields(event) {
      this.newFields = event;
    },
    submit(config) {
      const {
        volumes,
        origin_zip_code,
        destination_zip_code,
        additional_information,
      } = config;
      const configTransformed = Object.assign({}, {
        volumes: volumes
          .map((volume) => {
            const {
              weight,
              height,
              cost_of_goods,
              length,
              width,
            } = volume;

            return {
              weight,
              height,
              cost_of_goods,
              length,
              width,
            };
          }),
        origin_zip_code,
        destination_zip_code,
        additional_information,
      });
      configTransformed.logistic_contract_mode = false;
      const skip_return_modes = this.skip_return_modes;
      const skip_quote_rules = this.skip_quote_rules;
      const fields = this.fields;
      const contract_ids = Object.keys(this.listContractId)
        .map(k => this.listContractId[k])
        .flat();

      if (contract_ids.length === 0) {
        ScDialog.alert({
          title: 'Atenção!',
          confirmText: 'Fechar',
          message: 'É obrigatório selecionar pelo menos uma tabela de algum método de entrega.',
          type: 'is-primary',
          hasIcon: false,
          icon: 'times-circle',
        });
        return 0;
      }

      const debug = true;

      return this.quoteByVolume({
        configTransformed,
        fields,
        skip_return_modes,
        skip_quote_rules,
        contract_ids,
        debug,
      });
    },
    backUrl() {
      window.history.back();
    },
    addDeliveryMethod(delivery_method, origin_zip_code) {
      this.quoteGetContractsByDeliveryMethod({
        origin_zip_code,
        delivery_method_id: delivery_method.id,
        delivery_method_name: delivery_method.name,
      });

      this.fields.delivery_method = null;
      this.newFields.delivery_method = null;
    },
    deleteDeliveryMethods() {
      ScDialog.confirm({
        title: 'Limpar métodos de entrega',
        confirmText: 'Limpar',
        message: 'Tem certeza que deseja limpar todos os métodos de entrega?',
        type: 'is-primary',
        hasIcon: false,
        icon: 'times-circle',
        onConfirm: () => {
          this.resetContractList();
        },
      });
    },
  },
  mounted() {
    this.cleanUpdateContractId();
  },
  components: {
    ScForm,
    ScInput,
    ScField,
    ScBasicData,
    ScButton,
    ScSelect,
    ScLogisticContracts,
    ScVolume,
    ScSwitch,
    ScQuoteRules,
    ScQuoteTestReturn,
    ScRealTimeQuotation,
  },
};
</script>

<style lang="scss" scoped>
.button-add {
  margin-top: 29px;
}

.switch-skip {
  display: flex;
  text-align: right !important;
}

.switch-skip p {
  font-size: 15px
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-logistic-draft-test/ScLogisticDraftTest.vue?72b6a89c